<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" class="form-control" v-model="idDelModelo" @change="cambiarDatos($event)" :disabled="disabled">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} una área de jurisdicción</option>
        <option v-else="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todas.Nombre}} las juridicciones</option>
        <option v-for="jurisdiccion in jurisdicciones" :value="jurisdiccion.JurisdiccionId">{{jurisdiccion.Area.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios';
  import api from '@/../static/js/api';
  import comun from '@/../static/js/comun';

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        jurisdicciones: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      disabled: false,
      parametros: Object
    },
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }

      this.$store.dispatch("A_SINOJ_Catalogos_establecer003Jurisdicciones", parametros);
    },
    methods: {
      cargaCatalogoDeJurisdicciones: function() {
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba;
        this.parametros.conAreasDeJurisdiccion = true;

        let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);

        axios.post(api.conexion + api.SINOJ.catalogos.C003Jurisdicciones, this.parametros, headerPeticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.jurisdicciones = respuesta.data.Jurisdicciones;
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }

        this.$store.dispatch("A_SINOJ_Catalogos_establecer003Jurisdicciones", parametros);
        this.$emit("valorParaElPadre", evento);
      }
    },
    created() {
      this.cargaCatalogoDeJurisdicciones();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SINOJ/Comun/Catalogos/C003Jurisdicciones.vue